import { all } from "redux-saga/effects";

import authSaga from "./auth";
import brandSaga from "./brands";
export default function* rootSaga() {
  yield all([authSaga(), brandSaga()]);
}
